<template>
  <div class="clue-approve-detail">
    <bhNavBar title="审批详情"></bhNavBar>
    <div>
      <div class="title">转移前</div>
      <div class="review">
        <van-row class="vanRowStyle" type="flex" justify="space-around">
          <van-col span="24">
            <span class="boldFont">主要负责人：</span>
            <span class="normalFont">{{ getUserName(clueDetail.principalUserId) }}</span>
          </van-col>
          <van-col span="24">
            <span class="boldFont">次要负责人：</span>
            <span class="normalFont">{{ getUserName(clueDetail.secondUserId) }}</span>
          </van-col>
        </van-row>
      </div>
      <div class="title">转移后</div>
      <div class="review">
        <van-row class="vanRowStyle" type="flex" justify="space-around">
          <van-col span="24">
            <span class="boldFont">主要负责人：</span>
            <span class="normalFont">{{ getUserName(clueDetail.approvePrincipalUserId) }}</span>
          </van-col>
          <van-col span="24">
            <span class="boldFont">次要负责人：</span>
            <span class="normalFont">{{ getUserName(clueDetail.approveSecondUserId) }}</span>
          </van-col>
        </van-row>
      </div>
     </div>
  </div>
</template>

<script>
import bhNavBar from "@/components/bright/bh-navBar/navBar"
import { Row, Col } from 'vant'
import { initClueDetail } from "@/getData/getData";
import { localStorageGet } from "@/libs/util"
import { DICTIONARY, ALLUSERDICTIONARY } from "@/getData/mutation-types";

import {responseUtil} from "@/libs/brightUtil";

export default {
  name: "clueMoveApproveDetail",
  components: {
    bhNavBar,
    [Row.name]: Row,
    [Col.name]: Col
  },
  data() {
    return {
      clueDetail: {}
    }
  },
  watch: {
    $route: {
      handler(to) {
        this.getDetails(to.query.id)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getUserName(userId) {
      if (!userId) {
        return '未知'
      }
      if (typeof userId !== 'string') {
        userId = userId.toString()
      }
      const userList = localStorageGet(ALLUSERDICTIONARY)
      const arrUserIds = userId.split(',')
      let consultantNames = ''
      arrUserIds.forEach((item, index) => {
        const filterArr = userList.filter((user) => user.userId === item)
        if (filterArr.length > 0) {
          consultantNames += index === arrUserIds.length - 1 ? filterArr[0].username : filterArr[0].username + ','
        }
      })
      if (consultantNames !== '') {
        return consultantNames
      } else {
        return '未知'
      }
    },
    getDict(code) {
      if (code) {
        const firstCode = code.substring(0, 3)
        const DICT = localStorageGet(DICTIONARY)
        const arr = DICT[firstCode]
        if (arr) {
          const filterArr = arr.filter((item) => item.code === code)
          if (filterArr.length > 0) {
            return arr.filter((item) => item.code === code)[0]['label']
          }
        }
      }
      return code
    },
    getDetails(id) {
      var that = this
      initClueDetail(id).then(function (res) {
        responseUtil.dealResponse(that, res, () => {
          that.clueDetail = res.data
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.clue-approve-detail {
  .title {
    font-size: 12px;
    margin: 15px 15px 5px 15px;
    color: #6D00FB;
    font-weight: bold;
    text-align: left;
    font-family: PingFangSC-Semibold;
  }
  .position-tag {
    font-size: 12px;
    margin: 15px 15px 5px 15px;
    background-color: #EDF5FF;
    border-radius: 3px;
    padding: 5px 14px;
    text-align: center;
  }
  .review {
    margin: 0 15px 15px 15px;
    height: auto;
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    padding-bottom: 0.2rem;
    .vanRowStyle {
      width: 95%;
      margin: auto;
      .boldFont {
        font-size: 14px;
        font-weight: bold;
      }
      .normalFont {
        font-size: 13px;
        font-weight: normal;
        color: #999;
      }
    }
  }
  .bottom-Site{
    width: 100%;
    height: 60px;
  }
  .bottom {
    width: 100%;
    height: 50px;
    position: fixed;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    bottom: 0px;
    background-color: rgba(248, 248, 248, 1);
    box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.07);
  }
}
</style>
